"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddMotherPlantModal = AddMotherPlantModal;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var mother_room_1 = require("../../../constants/mother-room");
var mother_plant_1 = require("../../../features/apis/mother-plant");
var api_error_message_1 = require("../../../utils/api-error-message");
var client_scoped_query_1 = require("../../../utils/client-scoped-query");
var button_component_1 = require("../../ui/button-component");
var dropdown_component_1 = require("../../ui/dropdown-component");
var labeled_field_1 = require("../../ui/labeled-field");
var labeled_text_field_1 = require("../../ui/labeled-text-field");
var text_component_1 = require("../../ui/text-component");
var area_select_field_1 = require("./area-select-field");
var starting_material_select_field_1 = require("./starting-material-select-field");
function AddMotherPlantModal(props) {
    var _this = this;
    var isOpen = props.isOpen, facilityId = props.facilityId, onClose = props.onClose;
    var clientId = (0, client_scoped_query_1.useActiveClientId)();
    var _a = (0, react_3.useState)(), seed = _a[0], setSeed = _a[1];
    var _b = (0, react_3.useState)(""), areaId = _b[0], setAreaId = _b[1];
    var _c = (0, react_3.useState)("1"), quantity = _c[0], setQuantity = _c[1];
    var _d = (0, react_3.useState)(mother_room_1.DEFAULT_MOTHER_TYPE), motherType = _d[0], setMotherType = _d[1];
    var _e = (0, react_3.useState)(""), dateAcquired = _e[0], setDateAcquired = _e[1];
    var _f = (0, react_3.useState)(""), notes = _f[0], setNotes = _f[1];
    var _g = (0, react_3.useState)(""), error = _g[0], setError = _g[1];
    var _h = (0, mother_plant_1.useCreateMotherPlantMutation)(), createMotherPlant = _h[0], isSaving = _h[1].isLoading;
    var requestTokenRef = (0, react_3.useRef)(0);
    // A synchronous lock also catches a second click before React renders the mutation's loading state.
    var requestInFlightRef = (0, react_3.useRef)(false);
    (0, react_3.useEffect)(function () { return function () {
        requestTokenRef.current += 1;
    }; }, []);
    var availableQuantity = seed === null || seed === void 0 ? void 0 : seed.quantity;
    var quantityValue = Number(quantity);
    var exceedsAvailable = typeof availableQuantity === "number" && quantityValue > availableQuantity;
    var isFormComplete = !!seed && !!areaId && Number.isInteger(quantityValue) && quantityValue > 0 && !exceedsAvailable;
    var handleClose = function () {
        if (requestInFlightRef.current || isSaving) {
            return;
        }
        requestTokenRef.current += 1;
        setSeed(undefined);
        setAreaId("");
        setQuantity("1");
        setMotherType(mother_room_1.DEFAULT_MOTHER_TYPE);
        setDateAcquired("");
        setNotes("");
        setError("");
        onClose();
    };
    var handleCreate = function () { return __awaiter(_this, void 0, void 0, function () {
        var requestToken, response, caught_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (requestInFlightRef.current || isSaving) {
                        return [2 /*return*/];
                    }
                    setError("");
                    if (!clientId) {
                        setError("No active client selected.");
                        return [2 /*return*/];
                    }
                    if (!seed || !isFormComplete) {
                        setError(exceedsAvailable ? "Only ".concat(availableQuantity, " available on this starting material.") : "Please complete all required fields.");
                        return [2 /*return*/];
                    }
                    requestToken = requestTokenRef.current;
                    requestInFlightRef.current = true;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, createMotherPlant({
                            clientId: clientId,
                            seed_id: seed.id,
                            area_id: areaId,
                            quantity: quantityValue,
                            mother_type: motherType,
                            date_acquired: dateAcquired || undefined,
                            notes: notes.trim() || undefined,
                        }).unwrap()];
                case 2:
                    response = _a.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    if (!response.success) {
                        setError(response.message || "Unable to create mother plants. Please try again.");
                        return [2 /*return*/];
                    }
                    requestInFlightRef.current = false;
                    handleClose();
                    return [3 /*break*/, 5];
                case 3:
                    caught_1 = _a.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    setError((0, api_error_message_1.getApiErrorMessage)(caught_1, "Unable to create mother plants. Please try again."));
                    return [3 /*break*/, 5];
                case 4:
                    requestInFlightRef.current = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isOpen, onOpenChange: function (open) {
            if (!open)
                handleClose();
        }, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Backdrop, { isDismissable: !isSaving, isKeyboardDismissDisabled: isSaving, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Container, { children: (0, jsx_runtime_1.jsxs)(react_1.Modal.Dialog, { className: "sm:max-w-[560px]", children: [(0, jsx_runtime_1.jsx)(react_1.Modal.CloseTrigger, { isDisabled: isSaving, onPress: handleClose }), (0, jsx_runtime_1.jsx)(react_1.Modal.Header, { children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1", children: [(0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "large", color: "dark-gray-1", weight: "bold", label: "New Mother Plant" }), (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "medium-gray", label: "Propagate one or more mother plants from accepted starting material." })] }) }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Body, { className: "p-1 flex flex-col gap-3", children: [!facilityId ? ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center gap-3 py-6 text-center", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:buildings-2-linear", fontSize: 32, className: "text-medium-gray" }), (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "medium-gray", label: "Select a facility first to create a mother plant." })] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(starting_material_select_field_1.StartingMaterialSelectField, { isActive: isOpen, facilityId: facilityId, selectedSeed: seed, onSelect: setSeed, isDisabled: isSaving }), (0, jsx_runtime_1.jsx)(labeled_text_field_1.LabeledTextField, { label: "Number of Mother Plants", type: "number", value: quantity, onChange: setQuantity, placeholder: "Number of mother plants to create", isRequired: true, isDisabled: isSaving }), exceedsAvailable && (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "xsmall", color: "red-600", label: "Only ".concat(availableQuantity, " available on this starting material.") }), (0, jsx_runtime_1.jsx)(labeled_field_1.LabeledField, { label: "Mother Type", children: (0, jsx_runtime_1.jsx)(dropdown_component_1.DropdownComponent, { ariaLabel: "Mother Type", options: mother_room_1.MOTHER_TYPE_OPTIONS, selectedKey: motherType, onSelectionChange: setMotherType }) }), (0, jsx_runtime_1.jsx)(area_select_field_1.AreaSelectField, { isActive: isOpen, facilityId: facilityId, selectedAreaId: areaId, onSelect: setAreaId, isDisabled: isSaving }), (0, jsx_runtime_1.jsx)(labeled_text_field_1.LabeledTextField, { label: "Date Acquired", type: "date", value: dateAcquired, onChange: setDateAcquired, isDisabled: isSaving }), (0, jsx_runtime_1.jsx)(labeled_text_field_1.LabeledTextField, { label: "Notes", value: notes, onChange: setNotes, placeholder: "Notes (optional)", isDisabled: isSaving })] })), error && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: error }) }))] }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Footer, { children: [(0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Cancel", onPress: handleClose, isDisabled: isSaving, variant: "secondary" }), (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: quantityValue > 1 ? "Create Mother Plants" : "Create Mother Plant", onPress: handleCreate, isPending: isSaving, isDisabled: !isFormComplete, color: "white", backgroundColor: "primary-navy", hoverColor: "primary-navy-light" })] })] }) }) }) }));
}
